module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/6th/campaign_banner_df65b35ccc39815789cfbf84df8b07af.jpg";